export default {
  stripe_session: null,
  checkout_link: null,
};
